export const CONFIGS_SET_LIST_DATA = 'CONFIGS_SET_LIST_DATA';
export const CONFIGS_SET_LIST_META = 'CONFIGS_SET_LIST_META';
export const CONFIGS_TITLE = 'cấu hình';